import VideocamIcon from '@mui/icons-material/Videocam';
import { Box, Card, Chip, Tooltip, Typography } from '@mui/material';
import { getLocaleDateWithTimeCustom } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import AvatarListGroup from '../AvatarListGroup';


function DashboardVideoCard({ meeting }) {

    const userList = useSelector(state => state.user.data || []);

    let users = meeting.users
    let mUsers = []
    users.forEach(element => {
        const user = userList.find(item => item.id === element);
        mUsers.push(user)
    });


    const handleCardClick = () => {

        if (meeting.meetingUrl) {
            window.open(meeting.meetingUrl, '_blank', 'noopener,noreferrer');
        } else {
            console.error("Meeting URL bulunamadı!");
        }
    };

    const { dshVideoBackgroundcolor, dshVideoChip } = useTemplateFontSettings();

    return (
        <Card
            sx={{
                backgroundColor: dshVideoBackgroundcolor,
                minHeight: '140px',
                padding: '7px',
                overflow: 'hidden',
            }}
            onClick={() => handleCardClick()}
        >
            <Tooltip
                title="Video konferansa katılmak için dokunun lütfen"
                arrow
                style={{ color: "#424242", cursor: 'pointer' }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0, m: 0 }}>
                    {/* Header: Icon ve Chip */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            p: 0,
                            marginBottom: '5px'
                        }}
                    >
                        <VideocamIcon style={{ color: "#c2185b" }} />
                        <Chip
                            size="small"
                            label={`${meeting.decisionCount} Madde`}
                            sx={{
                                bgcolor: dshVideoChip,
                                padding: '0',
                                color: '#ffffff'
                            }}
                        />
                    </Box>
                    {/* İçerik Bölümü */}
                    <Box sx={{ mt: 1, p: 0, m: 0 }}>
                        <Box
                            sx={{
                                height: '40px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    color: '#424242'
                                }}
                            >
                                {meeting.inst}    {meeting.unit}
                            </Typography>
                        </Box>
                        <hr style={{ margin: '2px 0' }} />
                        <Typography
                            sx={{ textAlign: 'left', color: '#424242' }}
                        >
                            Sayı: {meeting.meetingNo}
                        </Typography>
                        <Typography
                            sx={{ textAlign: 'left', color: '#424242' }}
                        >
                            Tarih: {getLocaleDateWithTimeCustom('tr', meeting.pdate)}
                        </Typography>
                        <Box sx={{ textAlign: 'left', p: 0, m: 0 }}>
                            <AvatarListGroup users={mUsers} />
                        </Box>
                    </Box>
                </Box>
            </Tooltip>
        </Card>
    );
}

export default DashboardVideoCard;
